import React from 'react';
var DataTableContext = React.createContext({});
export default DataTableContext;
